import React from 'react';
import {FieldViewSmallProps} from "../../../../render/view-small";


export default function FieldDocumentAccess_ViewSmall(props:FieldViewSmallProps) {

    const value = props.model[props.field.fieldId]

    return  (
        <div className={Classes("flex-row-left-center lh-20 txt-truncate", props.className)}>
            <div className={Classes('ui5-ico-12 m-r-5', props.options?.iconClassName, props.field.icon)}/>
            <div className="ui5-txt-less-important-small txt-truncate">{props.field.getDisplayValue(value)}</div>
        </div>
    )
}